(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-retour-site"]) return;
  try {
    
if (!customElements.get('cdc-retour-popup')) {
  customElements.define('cdc-retour-popup', class extends HTMLElement {
    connectedCallback() { this.setupTimer = setTimeout(() => this.setup(), 0); }
    setup() {
      if (!this.isConnected) return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.editor = this.dataset.editor === 'true';
      this.key = this.dataset.key;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelectorAll('[data-retour-close]').forEach(button => {
        button.addEventListener('click', () => this.dialog.close(), options);
      });
      this.querySelectorAll('[data-retour-preview]').forEach(button => {
        button.addEventListener('click', () => this.open(), options);
      });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.unlock(), options);
      if (this.editor) {
        document.addEventListener('shopify:section:select', event => {
          if (event.detail.sectionId === this.dataset.section) this.open();
          else if (this.dialog.open) this.dialog.close();
        }, options);
        document.addEventListener('shopify:section:deselect', event => {
          if (event.detail.sectionId === this.dataset.section) this.dialog.close();
        }, options);
        if (this.dataset.preview === 'true') this.open();
        return;
      }
      if (this.dataset.enabled !== 'true' || this.seen()) return;
      const now = Date.now();
      let start = Number(this.read('start'));
      if (!start || start > now) { start = now; this.write('start', String(start)); }
      this.due = start + (Number(this.dataset.delay) || 300) * 1000;
      this.check = () => {
        clearTimeout(this.timer);
        if (!this.isConnected || this.seen()) return;
        const remaining = this.due - Date.now();
        if (remaining > 0) { this.timer = setTimeout(this.check, remaining); return; }
        if (document.hidden) return;
        // This theme's newsletter uses .promo-popup rather than a native dialog.
        const others = document.querySelectorAll('dialog[open], [aria-modal="true"], [role="dialog"], promo-popup .promo-popup, .popup-overlay');
        if ([...others].some(node => !this.contains(node) && this.visible(node))) {
          this.timer = setTimeout(this.check, 1000); return;
        }
        this.open();
      };
      document.addEventListener('visibilitychange', this.check, options);
      this.check();
    }
    visible(node) {
      const r = node.getBoundingClientRect();
      if (r.width <= 0 || r.height <= 0 || r.bottom <= 0 || r.right <= 0 || r.top >= window.innerHeight || r.left >= window.innerWidth) return false;
      for (let ancestor = node; ancestor; ancestor = ancestor.parentElement) {
        const s = getComputedStyle(ancestor);
        if (s.display === 'none' || s.visibility === 'hidden' || s.opacity === '0') return false;
      }
      return true;
    }
    read(suffix, persistent = false) {
      try { return (persistent ? localStorage : sessionStorage).getItem(this.key + ':' + suffix); }
      catch (_) { return this[suffix + 'Fallback'] || null; }
    }
    write(suffix, value, persistent = false) {
      this[suffix + 'Fallback'] = value;
      try { (persistent ? localStorage : sessionStorage).setItem(this.key + ':' + suffix, value); } catch (_) {}
    }
    seen() {
      if (this.read('seen')) return true;
      const days = Number(this.dataset.repeat) || 0;
      const last = Number(this.read('last', true));
      return days > 0 && last > 0 && Date.now() - last < days * 86400000;
    }
    open() {
      if (!this.isConnected || this.dialog.open) return;
      this.dialog.showModal();
      this.previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.locked = true;
      if (!this.editor) {
        this.write('seen', '1');
        if (Number(this.dataset.repeat) > 0) this.write('last', String(Date.now()), true);
      }
    }
    unlock() {
      if (!this.locked) return;
      if (document.body.style.overflow === 'hidden') document.body.style.overflow = this.previousOverflow;
      this.locked = false;
    }
    disconnectedCallback() {
      clearTimeout(this.setupTimer); clearTimeout(this.timer);
      if (this.dialog && this.dialog.open) this.dialog.close();
      this.unlock();
      if (this.controller) this.controller.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
